$(function () {
    $('.navbar__item--dropdown').on('click', function() {
        $(this).toggleClass('navbar__item--dropdown--expanded');
    })
})


// WEBPACK FOOTER //
// ./resources/assets/js/components/menu-animation.js